import React, { useEffect, useMemo, useState } from 'react'
import { LANG_FLAGS, LANG_LABELS } from '../pages/admin/tools/adminToolShared'
import { ModalClose } from './icons'

export default function TranslationViewer({ file, initialLang, onClose }) {
  const langs = useMemo(
    () => Object.keys(file?.translationTexts || {}),
    [file?.translationTexts],
  )
  const [activeLang, setActiveLang] = useState(initialLang || langs[0] || null)

  useEffect(() => {
    if (!langs.length) {
      setActiveLang(null)
      return
    }
    if (initialLang && langs.includes(initialLang)) {
      setActiveLang(initialLang)
      return
    }
    setActiveLang((prev) => (prev && langs.includes(prev) ? prev : langs[0]))
  }, [file?.id, initialLang, langs])

  const activeText = activeLang ? file.translationTexts?.[activeLang] : ''
  const isFailed = file.translations?.[activeLang] === 'failed'

  return (
    <div className="admin-modal-overlay show admin-translation-overlay" onClick={onClose}>
      <div className="admin-modal admin-translation-viewer" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header admin-translation-viewer-header">
          <div className="admin-translation-viewer-title">
            <h3>Translation</h3>
            <p className="admin-modal-subtitle">{file.name}</p>
          </div>
          <ModalClose onClick={onClose} />
        </div>

        {langs.length > 0 ? (
          <>
            <div className="admin-translation-viewer-tabs" role="tablist" aria-label="Translation languages">
              {langs.map((lang) => {
                const failed = file.translations?.[lang] === 'failed'
                return (
                  <button
                    key={lang}
                    type="button"
                    role="tab"
                    aria-selected={activeLang === lang}
                    className={`admin-translation-viewer-tab${activeLang === lang ? ' active' : ''}${failed ? ' failed' : ''}`}
                    onClick={() => setActiveLang(lang)}
                  >
                    <span className="admin-translation-viewer-tab-flag">{LANG_FLAGS[lang] || '🌐'}</span>
                    <span>{LANG_LABELS[lang] || lang}</span>
                    {failed && <span className="admin-translation-viewer-tab-badge">Failed</span>}
                  </button>
                )
              })}
            </div>
            <div className="admin-translation-viewer-content" role="tabpanel">
              {isFailed && (
                <p className="admin-translation-viewer-alert">
                  Translation failed or returned a placeholder. Content below may be incomplete.
                </p>
              )}
              <div className="admin-translation-viewer-text">{activeText || 'No content for this language.'}</div>
            </div>
          </>
        ) : (
          <div className="admin-translation-viewer-content admin-translation-viewer-empty">
            <p>No translation content yet.</p>
          </div>
        )}

        <div className="admin-modal-footer admin-translation-viewer-footer">
          <button type="button" className="admin-btn secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  )
}
